import { createReducer, INITIAL_STATE } from '@shared/redux';

export const GET_SIDE_MENU_OPTIONS = '@sidebar/GET_SIDE_MENU_OPTIONS';
export const SET_SIDE_MENU_OPTION_SELECTED = '@sidebar/SET_SIDE_MENU_OPTION_SELECTED';

export const onSideMenuOptionClick = optionText => ({
    type: SET_SIDE_MENU_OPTION_SELECTED,
    payload: {
        optionText,
    },
});

const initialState = {
    optionSelected: '',
};

export const sideMenuReducer = createReducer({
    [INITIAL_STATE]: initialState,
    [SET_SIDE_MENU_OPTION_SELECTED]: (_, action) => ({
        optionSelected: action.payload.optionText,
    }),
});
